/**
 * AppVersionDeleteReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AppVersionDeleteReq
 */
export interface AppVersionDeleteReq {
  [key: string]: any
}

/**
 * AppVersionDeleteReq Schema
 */
export const AppVersionDeleteReqSchema: SchemaDefinition = {
  properties: {},
  type: 'object',
}
